import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Carousel from 'nuka-carousel';
import { Link } from 'react-router-dom';

import { APIHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';
import i18n from 'i18n-react';

const typePriority = {
  alert: 0,
  message: 1,
  contest: 2,
  badge: 3,
  'content-update': 4,
  events: 5,
};

const typeToColor = {
  alert: '#FF6666',
  message: '#66CCFF',
  contest: '#66CC66',
  badge: '#CC66CC',
  'content-update': '#FFFF99',
  events: '#FF9966',
};

const typeToIcon = {
  alert: 'triangle-exclamation',
  message: 'hand-wave',
  contest: 'circle-dollar',
  badge: 'award',
  'content-update': 'memo-circle-check',
  events: 'calendar',
};

const compareTypePriority = (a, b) => {
  if (typePriority[a.type] < typePriority[b.type]) {
    return -1;
  } else if (typePriority[a.type] > typePriority[b.type]) {
    return 1;
  }
  return 0;
};

const NotificationSlider = ({
  appId,
  top,
  middle,
  bottom,
  left,
  center,
  right,
}) => {
  const [notifications, setNotifications] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchNotifications = async () => {
      const res = await APIHandler.getAnnouncement(appId);
      if (res.length > 1) {
        setNotifications(res.sort(compareTypePriority));
      } else {
        setNotifications(res);
      }
    };

    if (appId > 0) {
      fetchNotifications();
    }
  }, [appId]);

  const trackShare = (url) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      const email = userObj?.email || 'Guest';
      APIHandler.trackEvent(
        appId,
        email,
        'collateral',
        'notification',
        url,
        'notification'
      );
    });
  };

  return (
    <>
      {notifications.length > 0 && (
        <div className="notification-slider__holder">
          <div
            className={`notification-slider__container 
              ${top ? 'top' : ''} ${middle ? 'middle' : ''} ${
              bottom ? 'bottom' : ''
            } 
              ${left ? 'left' : ''} ${center ? 'center' : ''} ${
              right ? 'right' : ''
            } ${notifications[currentIndex]?.type || 'default'}
            `}
            style={{
              borderBottom: `3px solid ${
                typeToColor[notifications[currentIndex]?.type]
              }`,
            }}
          >
            <h4>{i18n.translate('notification.newAndNow')}</h4>
            <div
              className={`notification-header ${
                notifications[currentIndex]?.type || 'default'
              }`}
              style={{
                borderBottom: `1px solid white`,
                borderTop: `1px solid white`,
              }}
            >
              <FontAwesomeIcon
                icon={['far', typeToIcon[notifications[currentIndex]?.type]]}
                style={{
                  color: `${typeToColor[notifications[currentIndex]?.type]}`,
                }}
              />
              <h4
              // style={{
              //   color: `${typeToColor[notifications[currentIndex]?.type]}`,
              // }}
              >
                {i18n.translate(
                  `notification.${notifications[currentIndex]?.type}`
                )}
              </h4>
            </div>
            <Carousel
              className="notification-slider__carousel"
              autoplay={notifications.length > 1}
              autoplayInterval={15000}
              wrapAround
              pauseOnHover
              slideIndex={currentIndex}
              afterSlide={setCurrentIndex}
              height="75%"
              maxHeight="27rem"
              getControlsContainerStyles={(key) => {
                switch (key) {
                  case 'CenterRight':
                    return {
                      right: '-3rem',
                    };
                  case 'CenterLeft':
                    return {
                      left: '-3rem',
                    };
                  case 'BottomCenter':
                    return {
                      bottom: '-2rem',
                    };
                  default:
                }
              }}
              withoutControls={notifications.length === 1}
              renderCenterLeftControls={({ previousSlide }) => (
                <button
                  className="carousel__slide-button"
                  onClick={previousSlide}
                  type="button"
                >
                  <FontAwesomeIcon icon={['fas', 'angle-left']} />
                </button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <button
                  className="carousel__slide-button"
                  onClick={nextSlide}
                  type="button"
                >
                  <FontAwesomeIcon icon={['fas', 'angle-right']} />
                </button>
              )}
              defaultControlsConfig={{
                pagingDotsStyle: {
                  fill: 'white',
                },
              }}
            >
              {notifications.map(({ id, message, weblink, type }, index) => {
                const fileExtension = weblink.split('/').pop().split('.').pop();
                const openInFancybox = ['pdf', 'png', 'jpg'];
                const filteredMessage = message.replaceAll('<p><br></p>', '');
                // const messageLength = filteredMessage
                //   .replace('<p>', '')
                //   .replace('</p>', '').length;

                console.log(fileExtension, openInFancybox, weblink);

                return (
                  <div key={id} className={`notification`}>
                    {!weblink ? (
                      <div
                        className="notification__message"
                        dangerouslySetInnerHTML={{ __html: filteredMessage }}
                      />
                    ) : openInFancybox.includes(fileExtension) ? (
                      <a
                        className="notification__weblink"
                        data-fancybox
                        data-type="iframe"
                        data-src={weblink}
                        href={weblink}
                        onClick={() => trackShare(weblink)}
                      >
                        <div
                          className="notification__message"
                          dangerouslySetInnerHTML={{ __html: filteredMessage }}
                        />
                      </a>
                    ) : weblink.includes('http') ? (
                      <a
                        className="notification__weblink"
                        target="_blank"
                        href={weblink}
                        rel="noreferrer"
                        onClick={() => trackShare(weblink)}
                      >
                        <div
                          className="notification__message"
                          dangerouslySetInnerHTML={{ __html: filteredMessage }}
                        />
                      </a>
                    ) : (
                      <Link
                        className="notification__weblink"
                        to={weblink}
                        key={id}
                        onClick={() => trackShare(weblink)}
                      >
                        <div
                          className="notification__message"
                          dangerouslySetInnerHTML={{ __html: filteredMessage }}
                        />
                      </Link>
                    )}
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationSlider;

NotificationSlider.propTypes = {
  appId: PropTypes.number.isRequired,
  top: PropTypes.bool,
  middle: PropTypes.bool,
  bottom: PropTypes.bool,
  left: PropTypes.bool,
  center: PropTypes.bool,
  right: PropTypes.bool,
};

NotificationSlider.defaultProps = {
  top: false,
  middle: false,
  bottom: false,
  left: false,
  center: false,
  right: false,
};
